class ProductV12Finance extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    super.setupListeners()

    this.handleTrigger = this.handleTrigger.bind(this)

    this.listeners.add(document, 'click', this.handleTrigger)
  }

  async handleTrigger (event) {
    const trigger = event.target.closest(
      '[data-product-v12-finance-external-el="trigger"]',
    )

    if (!trigger) return

    if (this.els.title.exists) {
      this.els.title.element.textContent = trigger.dataset.drawerTitle || ''
    }

    await window.BAO.sectionRenderer
      .fetchSingle('product-v12-finance', trigger.dataset.productUrl)
      .then((res) => {
        const newDOM = window.BAO.sectionRenderer.convertToDOM(res)

        const bodyContent = newDOM.querySelector(
          '[data-V12Finance-details-el="V12Finance"]',
        )

        this.els.body.element.innerHTML = bodyContent.outerHTML

        window.drawers.activeDrawerKey = 'product-v12-finance'
      })
      .catch(() => {
        window.drawers.activeDrawerKey = ''
      })
  }
}

if (!customElements.get('product-v12-finance')) {
  customElements.define('product-v12-finance', ProductV12Finance)
}
